module.exports = __webpack_public_path__ + "img/equine-on-horse.776a328d.jpg";